// CcAvenueRedirect.tsx
import React, { useEffect, useRef, useState } from "react";
import AppConfig from "../../../config";

type InitiateResp = { actionUrl: string; encRequest: string; accessCode: string; };
type RequestBody = {
    tid?: string;
    merchant_id?: string;   // optional; you can omit and let server use config
    order_id: string;
    amount: string;         // keep as string "1500.00"
    currency: string;
    redirect_url: string;
    cancel_url: string;
    language?: string;

    billing_name?: string;
    billing_address?: string;
    billing_city?: string;
    billing_state?: string;
    billing_zip?: string;
    billing_country?: string;
    billing_tel?: string;
    billing_email?: string;

    delivery_name?: string;
    delivery_address?: string;
    delivery_city?: string;
    delivery_state?: string;
    delivery_zip?: string;
    delivery_country?: string;
    delivery_tel?: string;

    promo_code?: string;
    customer_identifier?: string;

    merchant_param1?: string;
    merchant_param2?: string;
    merchant_param3?: string;
    merchant_param4?: string;
    merchant_param5?: string;
};

export default function CcAvenueRedirect(props: RequestBody) {
    const formRef = useRef<HTMLFormElement>(null);
    const [payload, setPayload] = useState<InitiateResp | null>(null);

    useEffect(() => {
        (async () => {
            const res = await fetch(`${AppConfig.apiBaseUrl}/${AppConfig.candidate.ccavRequestURL}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(props),
            });
            const data: InitiateResp = await res.json();
            setPayload(data);
        })();
    }, [props]);

    useEffect(() => {
        if (payload && formRef.current) formRef.current.submit();
    }, [payload]);

    return (
        <>
            {/* Your centered loader */}
            <div style={{ position: "fixed", inset: 0, display: "grid", placeItems: "center" }}>
                <div style={{ textAlign: "center" }}>
                    {/* replace with your gif/image if you want */}
                    <div style={{ width: 52, height: 52, border: "6px solid #eee", borderTopColor: "#333", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
                    <p style={{ marginTop: 16, fontWeight: 700 }}>Please wait, Page Loading…</p>
                </div>
            </div>

            {payload && (
                <form ref={formRef} method="post" action={payload.actionUrl}>
                    <input type="hidden" name="encRequest" value={payload.encRequest} />
                    <input type="hidden" name="access_code" value={payload.accessCode} />
                </form>
            )}

            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </>
    );
}
